import {
  DocumentListCard,
  Text,
  YesLoading
} from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { LoadingContainer } from './styles'

const DownloaderLoading = ({ customMessage }: { customMessage?: string }) => {
  const { t } = useTranslation()

  return (
    <LoadingContainer
      className='h-100 w-100 position-fixed d-flex align-items-center justify-content-center text-center p-4'
      style={{
        top: 0,
        left: 0,
        background: '#fff',
        zIndex: 9999,
        color: '#000'
      }}
    >
      <DocumentListCard
        className='d-flex flex-column m-auto justify-content-center align-items-center p-4 w-100'
        style={{ minWidth: 269, maxWidth: 400 }}
      >
        <YesLoading />

        <Text
          as='h2'
          variant='content-emphasis-06'
          className='mt-4'
          style={{ textAlign: 'center' }}
        >
          {t('report.wait-a-moment')}
        </Text>

        <Text as='p' variant='content-04'>
          {t('report.can-take-some-minutes')}
        </Text>

        {customMessage && (
          <Text className='mt-4' as='p' variant='content-04'>
            {customMessage}
          </Text>
        )}
      </DocumentListCard>
    </LoadingContainer>
  )
}

export default DownloaderLoading
